// Set live, in the order the server allows it: a write returns the row to draft, so the saved
// config is probed with the inputs of the passing Send before the two transitions.
export const SET_LIVE_STEPS = [
  { id: 'save', label: 'Save draft' },
  { id: 'probe', label: 'Probe the saved draft with the same test values' },
  { id: 'validated', label: 'Mark validated' },
  { id: 'live', label: 'Go live' },
];

const transition = (fetch, apiBase, id, to) =>
  fetch(`${apiBase}/${id}/transition`, { method: 'POST', body: JSON.stringify({ to }) }).then((res) => res.instance);

// onStep(id, state, message?) reports each step; onSaved(instance) every row the server returns, so
// a sequence that stops halfway still leaves the caller holding the saved draft.
export const runSetLive = async ({ fetch, apiBase, instanceId, body, inputs, onStep, onSaved }) => {
  let instance = null;
  for (const step of SET_LIVE_STEPS) {
    onStep(step.id, 'running');
    try {
      if (step.id === 'save') {
        const res = await fetch(instanceId ? `${apiBase}/${instanceId}` : apiBase, {
          method: instanceId ? 'PUT' : 'POST',
          body: JSON.stringify(body),
        });
        instance = res.instance;
      } else if (step.id === 'probe') {
        const probe = await fetch(`${apiBase}/${instance.id}/probe`, { method: 'POST', body: JSON.stringify(inputs) });
        if (!probe.ok) throw new Error(probe.message || probe.code || 'The probe did not pass.');
      } else {
        instance = await transition(fetch, apiBase, instance.id, step.id);
      }
    } catch (err) {
      onStep(step.id, 'failed', err);
      return { instance, ok: false };
    }
    if (step.id !== 'probe') onSaved(instance);
    onStep(step.id, 'done');
  }
  return { instance, ok: true };
};
